import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-responsive-modal'
import "react-responsive-modal/styles.css";
import { reduxForm } from 'redux-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import  * as solidIcons  from '@fortawesome/free-solid-svg-icons'
import moment from 'moment';
import BackofficeEditCategory from './BackofficeEditCategory';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

moment.locale('it')

class BackofficeEditCategoryModal extends Component {

  static propTypes = {
    show:                 PropTypes.bool.isRequired,
    categoryId:           PropTypes.number,    
    onSaveCategory:       PropTypes.func.isRequired,
    onDeleteCategory:     PropTypes.func.isRequired,
    onCancelEditCategory: PropTypes.func.isRequired,
    onClose:              PropTypes.func.isRequired,
  }

  /**
   * --------------------------------------------------------------
   * @param {*} props 
   */
  constructor(props) {
    super(props)

    this.state = {      
      
    }    
    
    this.close                = this.close.bind(this)
    this.onDeleteCategory     = this.onDeleteCategory.bind(this)
    this.onSaveCategory       = this.onSaveCategory.bind(this)
    this.onCancelEditCategory = this.onCancelEditCategory.bind(this)
    
  }

  /**
   * --------------------------------------------------------------
   * 
   */
  stateInit() {

    this.setState({      
      
    })    

  }

  /**
   * --------------------------------------------------------------
   */
  componentDidMount() {
    
  }

  /**
   * --------------------------------------------------------------
   * @param {*} prevProps 
   */
  componentDidUpdate(prevProps) {       
     
  }

  /**
   * --------------------------------------------------------------
   */
  onDeleteCategory() {
    if ( this.props.onDeleteCategory != null ) 
      this.props.onDeleteCategory()

    this.close()
  }

  /**
   * --------------------------------------------------------------
   */
  onSaveCategory(categoryId) {
    if ( this.props.onSaveCategory != null ) {
      this.props.onSaveCategory(categoryId)
    }

    this.close()
  }

  /**
   * --------------------------------------------------------------
   */
  onCancelEditCategory() {
    if ( this.props.onCancelEditCategory != null )
      this.props.onCancelEditCategory()

    //this.close()
  }

  /**
   * --------------------------------------------------------------
   */
  close() {
    if ( this.props.onClose != null )
      this.props.onClose()     
        
  }

  /**
   * --------------------------------------------------------------
   * @returns 
   */
  render () {

    const {
      show,       
      categoryId
    } = this.props

    /*
    const {
      
    } = this.state
    */
      
    return (
      <Modal
        open={show}
        onClose={this.close}
        closeOnEsc={true}
        showCloseIcon={false}
        closeOnOverlayClick={false}
        classNames={{modal: 'app-modal-container'}}
        animationDuration={500}
        //focusTrapped={true}
        center
      >
        <h4 className="app-modal-title">
          <div style={{ flex: 10, textAlign : 'left'}}>
            { categoryId != null 
              ? <FontAwesomeIcon className="IconsRevNoAction"  size="1x" icon={solidIcons.faEdit} />
              : <FontAwesomeIcon className="IconsRevNoAction"  size="1x" icon={solidIcons.faPlusCircle} />
            }            
          </div>          
          <div style={{ flex: 80, textAlign : 'center' }}><strong>  { categoryId != null ? "MODIFICA" : "CREA NUOVA" } CATEGORIA </strong></div>          
          <div style={{ flex: 10, textAlign : 'right'}}>
            <OverlayTrigger placement="top" overlay={<Tooltip id={"tooltip-category-to-window"}>Chiudi finestra</Tooltip>}>
              <FontAwesomeIcon  onClick={ evt => this.close() } className="mainIconsRev"  size="1x" icon={solidIcons.faXmark} />
            </OverlayTrigger>
          </div>
        </h4> 
        
        <div className="col-md-12">
          <div className="app-modal-body">                                  
            <BackofficeEditCategory
              categoryId={categoryId}
              onSaveCategory={this.onSaveCategory}      
              onDeleteCategory={this.onDeleteCategory} 
              onCancelEditCategory={this.onCancelEditCategory}
            />
          </div>
        </div>           
        
      </Modal>
    )
  }
}

export default reduxForm({ form: 'BackofficeEditCategoryModal'})(BackofficeEditCategoryModal)
